import { call, put, takeEvery } from 'redux-saga/effects';

import quotationApi from '../../api/quotation';
import { FETCH_SALESFORCE_DATA } from '../DataServices/SFDataService/actions';

import * as Actions from './actions';

export function* getQuotation(action) {
  try {
    let quotation = yield call(quotationApi.fetchQuotation, action.opportunityId);
    yield put(Actions.quotationDataTerminateLoading(quotation));
  } catch (e) {
    console.log(e);
  }
}

export function* quotationListener() {
  yield takeEvery(FETCH_SALESFORCE_DATA, getQuotation);
}



// WEBPACK FOOTER //
// ./src/services/SFQuotationService/saga.js